module.exports = __webpack_public_path__ + "static/img/np.e1a5b411.svg";